module.exports = __webpack_public_path__ + "static/media/icon-news.46fd2962.svg";